<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>

<div class="cg3-select-field">
    <div class="cg3-host-text-field">
        <div class="cg3-text-field">
            <div class="cg3-host-form-field">
                <div class="cg3-form-field">
                    @if (label) {
                        <div class="cg3-host-form-field-header">
                            <div class="cg3-form-field-header cg3-text-field-header">
                                <div class="cg3-host-form-field-label">
                                    <form-field-label-pds3>
                                        <span>{{ label | wkTranslate }}</span>
                                    </form-field-label-pds3>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="cg3-host-form-field-body">
                        <div class="cg3-form-field-body cg3-text-field-body cg3-form-field-body-{{ size }}">
                            <div class="cg3-form-field-body-container">
                                <div class="cg3-host-select-field-body">
                                    <div
                                        class="cg3-select-field-body"
                                        kendoTooltip
                                        #tt="kendoTooltip"
                                        [tooltipTemplate]="template"
                                        filter="li.k-list-item, .k-input-inner"
                                        showOn="none"
                                        [showAfter]="0"
                                        (mouseover)="onMouseOver($event)"
                                        (mouseleave)="onMouseLeave()"
                                        [tooltipClass]="'kendo-dropdownlist-wrapper-tooltip'"
                                    >
                                        <kendo-dropdownlist
                                            #dropdownList
                                            [data]="data"
                                            [textField]="textField"
                                            [valueField]="valueField"
                                            [value]="value"
                                            (valueChange)="handleValueChange($event)"
                                            (blur)="onTouched()"
                                            fillMode="none"
                                            rounded="none"
                                            [size]="size"
                                            [virtual]="
                                                virtual
                                                    ? {
                                                          itemHeight: 32,
                                                          pageSize: 30,
                                                      }
                                                    : false
                                            "
                                            [listHeight]="196"
                                            [adaptiveMode]="virtual ? 'none' : 'auto'"
                                            [disabled]="disabled"
                                            [readonly]="readonly"
                                            [valuePrimitive]="valuePrimitive"
                                            [popupSettings]="{ appendTo: 'component', popupClass: 'dropdownlist-wrapper-popup', animate: false }"
                                            [tabindex]="disabled ? -1 : 0"
                                            (opened)="onOpen()"
                                            (close)="onClose()"
                                            class="wk-dropdownlist"
                                            [itemDisabled]="onItemDisabled"
                                            [showStickyHeader]="false"
                                        >
                                            @if (isGroupingEnabled) {
                                                <ng-template kendoDropDownListGroupTemplate let-groupName />
                                            }
                                            <ng-template kendoDropDownListValueTemplate let-dataItem>
                                                {{ dataItem | nestedValue: textField | wkTranslate }}
                                            </ng-template>
                                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                <div class="dropdownlist-wrapper-item" [class.disabled-item]="!dataItem || dataItem.disabled">
                                                    {{ dataItem | nestedValue: textField | wkTranslate }}
                                                </div>
                                            </ng-template>
                                        </kendo-dropdownlist>
                                        @if (disabled && tooltipIfDisabled) {
                                            <portal-pds3 elementId="wk-app__root">
                                                <tooltip-pds3
                                                    mode="description"
                                                    position="top"
                                                    [openDelay]="400"
                                                    [closeDelay]="50"
                                                    [targetSelector]="'#' + hostId"
                                                    flowClass="wk-ddlw-disabled-tooltip"
                                                >
                                                    {{ tooltipIfDisabled | wkTranslate }}
                                                </tooltip-pds3>
                                            </portal-pds3>
                                        }

                                        @if (readonly && tooltipIfReadonly) {
                                            <portal-pds3 elementId="wk-app__root">
                                                <tooltip-pds3
                                                    mode="description"
                                                    position="top"
                                                    [openDelay]="400"
                                                    [closeDelay]="50"
                                                    [targetSelector]="'#' + hostId"
                                                    flowClass="wk-ddlw-disabled-tooltip"
                                                >
                                                    {{ tooltipIfReadonly | wkTranslate }}
                                                </tooltip-pds3>
                                            </portal-pds3>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
